import React, {useState} from 'react';
import PropTypes from 'prop-types';
import styled from "@emotion/styled";
import CustomInputField from "../components/common/CustomInputField";
import ActionButton from "../components/common/Action Buttons/ActionButton";
import ActionButton2 from "../components/common/Action Buttons/ActionButton2";
import SearchFieldComponent from "../components/common/SearchFieldComponent";
import CustomChip1 from "../components/common/CustomChip1";
import CustomTextArea from "../components/common/CustomTextArea";
import Label1 from "../components/common/Label1";
import {FilledInput} from "@material-ui/core";
import CustomFileInput from "../components/common/CustomFileInput";
import CustomChip2 from "../components/common/CustomChip2";

const PageWrapper = styled.div`
  display: flex;
  overflow: hidden;
  height: calc(100vh - var(--header-height));
`;

const PageContent = styled.div`
    padding-left: 110px;
    padding-top: 40px;
    padding-bottom: 100px;

    flex-grow: 1;
    overflow-y: scroll;
`;

const SupportFieldsSection = styled.div`
    margin-bottom: 50px;
    max-width: 550px;

    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr;
    grid-row-gap: 32px;
`;

const ContentRow = styled.div`
    display: grid;
    grid-auto-flow: column;
    grid-column-gap: 32px;
`;

const PageActions = styled.div`
    position: fixed;
    bottom: 0;
    padding: 0 0 32px 110px;
    
    display: grid;
    grid-auto-flow: column;
    grid-column-gap: 16px;
`;

const SupportChipsWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
`;

const AttatchmentChipsWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
`;


const AttactmentsSection = styled.div`
    
`;

function Support(props) {
    const ticketInfo = {
        email: "",
        id: "",
        subject: "",
        description: "",
        attachments: "",
    };

    const [ticket, setTicket] = useState(ticketInfo);
    const [deviceQuery, setDeviceQuery] = useState("");
    const [selectedDevices, setSelectedDevices] = useState([]);
    const [devicesSearchResult, setDevicesSearchResult] = useState();

    const handleOnFieldChange = (e) => {
        const {name, value} = e.target;
        setTicket({
            ...ticket,
            [name]: value
        })
    };

    const handleOnSearchChange = (e) => {

    };

    const handleOnDeviceChipDelete = () => {

    };

    const handleOnAttachmentChipDelete = () => {

    };


    return (
        <PageWrapper>
            <PageContent>

                <SupportFieldsSection>

                    <ContentRow>

                        <CustomInputField label={"Email"}
                                          onChange={handleOnFieldChange}
                                          value={ticket.email}
                                          style={{marginRight: "30px"}}
                                          placeholder={"Enter email"}
                                          name={"email"}
                                          width={264}
                        />

                        <CustomInputField label={"Support Ticket"}
                                          onChange={handleOnFieldChange}
                                          value={ticket.id}
                                          placeholder={""}
                                          name={"id"}
                                          width={264}
                        />

                    </ContentRow>

                    <CustomInputField label={"Subject"}
                                      onChange={handleOnFieldChange}
                                      value={ticket.subject}
                                      placeholder={""}
                                      fullWidth={true}
                                      name={"subject"}/>

                    <CustomTextArea label={"Description"}
                                    onChange={handleOnFieldChange}
                                    value={ticket.description}
                                    placeholder={""}
                                    fullWidth={true}
                                    rows={8}
                                    name={"description"}/>
                </SupportFieldsSection>


                {/*Attatchments*/}

                <AttactmentsSection>

                    <div>
                        <AttatchmentChipsWrapper>
                            <CustomFileInput label={"Upload Attachment"}/>

                            <CustomChip2 style={{margin: "0 8px"}} label={"Test"}
                                         onDelete={handleOnAttachmentChipDelete}/>

                        </AttatchmentChipsWrapper>

                    </div>

                    <Label1>
                        <span> Add Device </span>
                        <SearchFieldComponent onSearchChange={handleOnFieldChange}
                                              placeholder={"Search by model, make, IMEI or serial number"}/>
                    </Label1>


                    <SupportChipsWrapper>
                        <CustomChip1 style={{margin: "8px"}} label={"test"} onDelete={handleOnDeviceChipDelete}/>
                    </SupportChipsWrapper>

                </AttactmentsSection>


            </PageContent>


            <PageActions>
                <ActionButton>
                    Send
                </ActionButton>

                <ActionButton2>
                    Cancel
                </ActionButton2>

            </PageActions>

        </PageWrapper>
    );
}

Support.propTypes = {};
Support.defaultProps = {};

export default Support;
